import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useAuth } from '../context/AuthContext';

export default function SubscribeWall({
  title = 'Subscribe to unlock this',
  description = 'Upgrade to Pro or Premium to access the full Casting Calls UK network.',
  feature = 'this feature',
  testId = 'subscribe-wall',
}) {
  const { user } = useAuth();
  const ctaPath = user ? '/pricing' : '/login';
  const ctaLabel = user ? 'View plans' : 'Sign in to continue';

  return (
    <Card className="border-[#002FA7]/25 bg-[#002FA7]/5 shadow-sm" data-testid={testId}>
      <CardContent className="p-5 sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex min-w-0 gap-3">
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-[#002FA7] text-white">
              <Lock className="h-5 w-5" />
            </span>
            <div className="min-w-0">
              <p className="text-lg font-bold text-theme-text">{title}</p>
              <p className="mt-1 text-sm leading-relaxed text-theme-muted">{description}</p>
              <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-[#002FA7]/25 bg-theme px-3 py-1 text-xs font-semibold text-[#002FA7]">
                <Sparkles className="h-3.5 w-3.5" />
                {feature} is included with Pro and Premium
              </div>
            </div>
          </div>

          <Button asChild className="min-h-11 w-full flex-shrink-0 bg-[#002FA7] text-white hover:bg-[#0055FF] sm:w-auto">
            <Link to={ctaPath}>{ctaLabel}</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
